import React from "react";
import OwTitle from "../../shared/OwTitle/OwTitle";
import {Form, Formik} from "formik";
import {OwFormikField} from "../../shared/OwFormikField/OwFormikField";
import {PasswordRequirements} from "../PasswordRequirements/PasswordRequirements";
import OwButton from "../../shared/OwButton/OwButton";
import UIService from "../../../services/UIService";
import UserService from "../../../services/UserService";

type Props = {};

export const ProfilePassword = (props: Props) => {
    const changePasswordSchema = UserService.getChangePasswordSchema();

    let cardClass = "card";

    const passwordInitialValues = {
        old_password: '',
        new_password: '',
        confirm_new_password: '',
    };

    if (!UIService.isMainViewLight()) {
        cardClass += " bg-dark text-white";
    }

    const handlePasswordSubmit = (values: typeof passwordInitialValues, { setSubmitting }: { setSubmitting: (isSubmitting: boolean) => void }) => {
        // Simulate an API call
        setTimeout(() => {
            console.log(values);
            setSubmitting(false);
            alert('Password changed successfully! (Simulated)'); // Replace with actual success message
        }, 2000);
    };

    return <div className={cardClass}>
        <div className="card-header">
            <OwTitle title={"password"}/>
        </div>
        <div className="card-body">
            <Formik
                initialValues={passwordInitialValues}
                onSubmit={handlePasswordSubmit}
                validationSchema={changePasswordSchema}
                isInitialValid={false}
            >
                {({ isSubmitting, isValid, values }) => {
                    return (<Form className="space-y-4">
                        <div className={"row"}>
                            <div className={"col-12 col-xl-6"}>
                                <OwFormikField
                                    label="Old Password"
                                    name="old_password"
                                    type="password"
                                    placeholder="enter_your_old_password"
                                />
                                <OwFormikField
                                    label="New Password"
                                    name="new_password"
                                    type="password"
                                    placeholder="enter_your_new_password"
                                />
                                <OwFormikField
                                    label="Confirm New Password"
                                    name="confirm_new_password"
                                    type="password"
                                    placeholder="confirm_your_new_password"
                                />
                            </div>

                            <div className={"col-12 col-xl-6"}>
                                <PasswordRequirements password={values.new_password}/>
                            </div>
                        </div>

                        <div className={"row"}>
                            <div className={"col-12"}>
                                <OwButton
                                    title={isSubmitting ? 'Changing...' : 'change_password'}
                                    disabled={isSubmitting || !isValid}
                                    type={"submit"}
                                />
                            </div>
                        </div>
                    </Form>)
                }}
            </Formik>
        </div>
    </div>;
};
